// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"4f9d9300","162":"47603bfd","168":"1ee4f1f5","289":"63239912","312":"207c9011","377":"c157e845","417":"6f7edfea","424":"ce108a08","480":"91e78a7a","540":"3e7e6411","839":"fdcd9c9a","884":"1e451b40","983":"af6742bb"}[chunkId] + ".chunk.js";
};